import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-topbar',
  templateUrl: './dashboard-topbar.component.html',
  styleUrls: ['./dashboard-topbar.component.scss'],
})
export class DashboardTopbarComponent {
  @Input() searchKeyword = '';
  @Input() userInitial = 'U';
  @Input() fullName = '';
  @Input() loginName = '';
  @Input() showSearch = true;

  @Output() searchKeywordChange = new EventEmitter<string>();
  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() openThemeModal = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  menuOpen = false;

  constructor(private router: Router) {}

  get displayName(): string {
    return this.fullName || this.loginName || 'Người dùng';
  }

  get profileTitle(): string {
    if (this.fullName && this.loginName && this.fullName !== this.loginName) {
      return `${this.fullName} (${this.loginName})`;
    }
    return this.displayName;
  }

  get showLoginAccount(): boolean {
    return !!this.loginName && this.loginName !== this.fullName;
  }

  onSearchInput(value: string): void {
    this.searchKeywordChange.emit(value);
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  goToProfile(): void {
    this.closeMenu();
    this.router.navigate(['/profile']);
  }

  onLogout(): void {
    this.closeMenu();
    this.logout.emit();
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.menuOpen) {
      this.closeMenu();
    }
  }
}
